module.exports = "/assets/data/c527daa7b48996f5ff90cacd3339b1cd-CA17.data.json";